import { Move } from "assets/icons/Common";
import { Color, ColorBox } from "material-ui-color";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useQuill } from "react-quilljs";
import { WidgetFC } from "types/Widget";
import { debounce } from "util/common";

import { FONTS, SIZE_VALUE } from "./constants";
import { MoveIconBtn, RTE } from "./FreeText.styles";
import useBgColorToolbar from "./hooks/bg-color-toolbar.hook";

const formatFontSettings = FONTS.map((f) => f.replaceAll(" ", "_"));

const Size: any = Quill.import("attributors/style/size");
const Fonts: any = Quill.import("formats/font");

Size.whitelist = SIZE_VALUE;
Fonts.whitelist = formatFontSettings;

Quill.register(Fonts, true);
Quill.register(Size, true);

const PLACEHOLDER = "Enter some text here...";

const FORMATS = ["font", "size", "bold", "italic", "underline", "list", "align", "color"];

export interface FreeTextContainerState {
  text?: string;
  color?: Color;
}

export const FreeTextBox: WidgetFC<FreeTextContainerState> = (props) => {
  const { setState, settings, widgetId, onClickPicker, state, pixelPosition } = props;

  const ref = useRef<any>(null);
  const rteId = widgetId.substring(0, 8);
  const [showPicker, setShowPicker] = useState(false);
  const [bgColor, setBgColor] = useState<Color>();
  const memoModules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ font: Fonts.whitelist }],
          [{ size: Size.whitelist }],
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ align: [] }],
          [{ color: [] }],
          ["colorpicker"], // Custom button for colorpicker
        ],
        handlers: {
          colorpicker: () => {
            setShowPicker(!showPicker);
            onClickPicker(true);
          },
        },
      },
    }),
    [showPicker, onClickPicker],
  );

  const { quill, quillRef } = useQuill({
    modules: memoModules,
    formats: FORMATS,
    placeholder: PLACEHOLDER,
  });

  // Adding a custom button in the toolbar
  useBgColorToolbar(quill, quillRef, bgColor);

  const handleTextChangeDebounced = useCallback(
    debounce(() => {
      if (!quill) return;
      const html = quill.root.innerHTML;
      console.log("moon tons");

      setState({
        color: bgColor,
        text: html,
      });
    }, 300),
    [bgColor, quill, setState],
  );

  const handleColorChangeDebounced = useCallback(
    debounce((value: Color) => {
      if (!quill) return;
      const html = quill.root.innerHTML;

      setState({
        color: value,
        text: html,
      });
    }, 300),
    [quill, setState],
  );

  useEffect(() => {
    if (!quill) return;

    const handleTextChange = () => {
      handleTextChangeDebounced();
    };

    quill.on("text-change", handleTextChange);
    return () => {
      quill.off("text-change", handleTextChange);
    };
  }, [quill, handleTextChangeDebounced]);

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowPicker(false);
        onClickPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (quill && !!state?.text) {
      quill.clipboard.dangerouslyPasteHTML(state.text);
      const length = quill.getLength();
      quill.setSelection(length, 0);
    }

    if (!!state?.color) setBgColor(state.color);
  }, [quill]);

  useEffect(() => {
    if (settings.fontFamily && quill) {
      const formattedInitialValue = settings.fontFamily.replaceAll(" ", "_");

      document
        .querySelector<HTMLElement>(`.mockId${rteId} [data-value="${formattedInitialValue}"]`)
        ?.click();
    }

    if (typeof settings.hasSpellCheck !== "undefined" && quill) {
      quill.root.setAttribute("spellcheck", `${settings.hasSpellCheck}`);
    }
  }, [quill, settings.fontFamily, settings.hasSpellCheck, rteId]);

  const handleColorChange = (value: Color) => {
    handleColorChangeDebounced(value);
    setBgColor(value);
  };
  console.log("inff");

  return (
    <div style={{ width: pixelPosition.width, height: pixelPosition.height }}>
      <RTE className={`mockId${rteId} rte`} isShowToolbar={settings.isShowToolbar}>
        <div ref={quillRef} />
      </RTE>
      <MoveIconBtn Icon={Move} />
      {showPicker && (
        <div
          ref={ref}
          style={{
            position: "absolute",
            right: "50px",
            top: "60px",
            padding: 1,
            boxShadow: "1px 1px 1px 1px rgba(0,0,0,0.25)",
          }}
        >
          <ColorBox defaultValue="transparent" value={bgColor} onChange={handleColorChange} />
        </div>
      )}
    </div>
  );
};
